// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"9ef21931","938":"89e18559","959":"6c76f939","967":"4978ac87"}[chunkId] + ".chunk.js";
};